import { useFeatureFlag } from '~/src/common/services/FeatureFlag/client';
import { SubCategory } from '~/src/common/typings/category';

import HomeCategory from './HomeSubcategory';
import * as S from './layout';
import MarketingHeaders from './MarketingHeaders';

interface Props {
  subCategories?: SubCategory[] | null;
  headersIds?: string[];
}

const HomeScreenContent = ({ subCategories, headersIds }: Props) => {
  const isFamiliesVisibleOnMobile = useFeatureFlag('show-families-home-mobile');

  const [firstSubCategory, secondSubCategory, ...restSubCategories] = subCategories ?? [];

  return (
    <>
      {firstSubCategory && subCategories ? (
        <HomeCategory
          subcategory={firstSubCategory}
          position={1}
          subcategoriesCount={subCategories.length}
        />
      ) : null}

      <MarketingHeaders headersIds={headersIds} />

      {secondSubCategory && subCategories ? (
        <HomeCategory
          subcategory={secondSubCategory}
          position={2}
          subcategoriesCount={subCategories.length}
        />
      ) : null}

      {isFamiliesVisibleOnMobile && <S.MobileIncentive />}

      {subCategories &&
        restSubCategories?.map((subcategory, index) => (
          <HomeCategory
            subcategory={subcategory}
            key={subcategory.id}
            position={index}
            subcategoriesCount={subCategories.length}
          />
        ))}
    </>
  );
};

export default HomeScreenContent;
